import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import {ProductModel} from '../product-model';
import {IecLeadTime} from '../../model/iec-lead-time';
import {Entity} from '../../entity/entity';
import {EntityLine} from '../../entity/entity-line';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {Sku} from '../../model/sku';
import {GuruEntity} from '../../model/guru-entity';
import {TagInformation} from '../../model/tag-information';
import {Observable, of} from 'rxjs';
import {ConfigurationSaveInformation} from '../../model/configuration-save-information';
import {SfrEntry} from '../../model/sfr-entry';

@Component({
    selector: 'app-unknown-product-model',
    templateUrl: './unknown-product-model.component.html',
    styleUrls: ['./unknown-product-model.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class UnknownProductModelComponent implements OnInit, ProductModel {

  readonly errorMessage = signal<string>(undefined!);
  readonly configurationLeadTime = signal<IecLeadTime>(undefined!);
  entity!: Entity;
  entityLeadTime!: IecLeadTime;
  readonly entityLine = signal<EntityLine>(undefined!);
  entityLineHeader!: EntityLineHeader;
  readonly sfrEntries = signal<SfrEntry[]>(undefined!);
  readonly skus = signal<Sku[]>(undefined!);
  slowestLeadTime!: IecLeadTime;
  readonly taggingDetails = signal<TagInformation[]>(undefined!);


  ngOnInit(): void {
    this.errorMessage.set('Unknown product ' + this.entityLine().product);
  }

  protected getModelPropertyName(): string {
    return '';
  }

  protected getImagePrefix(): string {
    return '';
  }

  applyMassUpdate(entities: GuruEntity[]): void {
  }

  initialize(): Observable<string> {
    return of('');
  }

  getSaveInformation(): ConfigurationSaveInformation {
    return null!;
  }

  saveUnit(): void {
  }

}
